import { useMutation } from '@tanstack/react-query';
import { differenceInSeconds } from 'date-fns';

import { createActionTimeTracker } from './api';

interface UseCreateTrackerProps {
  setTrackerGuid: (trackerGuid: string) => void;
  setSeconds: (seconds: number) => void;
}

export const useCreateTracker = (props: UseCreateTrackerProps) => {
  const { setTrackerGuid, setSeconds } = props;
  const { isLoading, mutate } = useMutation({
    mutationFn: createActionTimeTracker,
    onSuccess: ({ actionTimeTrackerGuid, startTime }) => {
      setTrackerGuid(actionTimeTrackerGuid);
      const secondsDifference = differenceInSeconds(new Date(), startTime);
      if (Math.abs(secondsDifference) > 60) {
        setSeconds(0);
      }
    },
  });

  return {
    createTracker: mutate,
    createTrackerLoading: isLoading,
  };
};
